import { Flex, Typography } from "antd";
import useStyles from "./NotFoundPage.styles";
import { Header } from "@/features/header";

const NotFoundPage = () => {
  const { styles } = useStyles();
  return (
    <Flex className={styles.page} justify="flex-start" align="center" vertical>
      <Header />
      <Flex className={styles.body} vertical justify="center" align="center" gap={12}>
        <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M11.25 6.25L6.25 11.25"
            stroke="#1677FF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.25 6.25L11.25 11.25"
            stroke="#1677FF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.75 16.75C13.1683 16.75 16.75 13.1683 16.75 8.75C16.75 4.33172 13.1683 0.75 8.75 0.75C4.33172 0.75 0.75 4.33172 0.75 8.75C0.75 13.1683 4.33172 16.75 8.75 16.75Z"
            stroke="#1677FF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.7531 18.7492L14.4531 14.4492"
            stroke="#1677FF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>{" "}
        <Typography.Text>Страница не найдена</Typography.Text>
      </Flex>
    </Flex>
  );
};
export default NotFoundPage;
